import NiceModal from '@ebay/nice-modal-react';

import { useDispatch } from 'react-redux';

import ConfirmationModal from 'components/global/ConfirmationModal';

import CreatePermissionLinkForm from 'pages/SupportAdmin/ClientUsers/CreatePermissionLinkForm';

import { USERS } from 'services/consts';

import { setLoading } from 'stores/layoutSlice';

import AppLogger from 'utils/AppLogger';
import { logout } from 'utils/configureStore';

import useAxiosPrivate from './useAxiosPrivate';
import useLocalStorage from './useLocalStorage';
import useRefreshToken from './useRefreshToken';

const useSwitchSupportClient = () => {
	const [setLastSwitchUsers] = useLocalStorage('lastSwitchUsers', []).reverse();
	const [setSupportAccessUntil] = useLocalStorage('supportAccessUntil', null).reverse();
	const [setSupportUserName] = useLocalStorage('supportUserName', null).reverse();

	const axiosPrivate = useAxiosPrivate();
	const dispatch = useDispatch();
	const refreshAccess = useRefreshToken();

	const switchSupportClient = (client) => {
		if (!client) {
			dispatch(setLoading(true));
			refreshAccess().then(() => {
				setSupportAccessUntil(null);
				setSupportUserName(null);
				window.location.href = window.location.origin;
			});
		} else if (client.status === 'Granted') {
			NiceModal.show(ConfirmationModal, {
				title: 'switchAccountTitle',
				subTitle: '',
				yesAction: () => {
					dispatch(setLoading(true));
					refreshAccess().then(() => {
						axiosPrivate
							.post(USERS.MOVE_SUPPORT_ACCESS, {
								SupportAccessRequest: client.SupportAccessRequest
							})
							.then((response) => {
								if (response?.status === 200 && response?.data?.success) {
									setLastSwitchUsers((prev) => [
										client,
										...prev.filter((user) => user.clientUserId !== client.clientUserId)
									]);
									const refreshToken = localStorage.getItem('REFRESH_TOKEN');
									dispatch(logout());
									localStorage.setItem('ACCESS_TOKEN', response.data.access_token);
									localStorage.setItem('REFRESH_TOKEN', refreshToken);
									const now = new Date();
									now.setHours(now.getHours() + 1);
									setSupportAccessUntil(now.getTime());
									window.location.href = window.location.origin;
								}
							})
							.catch((error) => {
								dispatch(setLoading(false));
								AppLogger.error(error);
							});
					});
				},
				confirmLabel: 'yes',
				rejectLabel: 'cancel'
			});
		} else {
			NiceModal.show(ConfirmationModal, {
				title: 'switchAccountExpiredTitle',
				subTitle: '',
				yesAction: () => NiceModal.show(CreatePermissionLinkForm),
				confirmLabel: 'permissionLink',
				rejectLabel: 'cancel'
			});
		}
	};
	return switchSupportClient;
};

export default useSwitchSupportClient;
